

import { Folder } from "lucide-react";
import right_photo from "../images/right_photo.png";
import left_photo from "../images/left_photo.png"

export default function About() {
  return (
    <div className="text-gray-200 px-0 sm:px-6 lg:px-8 mb-12 md:mb-0">

      {/* Heading */}
      <h1 className="text-[28px] sm:text-[40px] lg:text-[45px] font-semibold mt-[-20px] sm:mt-[-40px] lg:mt-[-50px]">
        Digital Identity
      </h1>

      <hr className="h-[3px] sm:h-[5px] bg-cyan-300 border-0 mt-3 w-[70px] sm:w-[100px]" />

      {/* Intro Paragraph */}
      <p className="mt-8 sm:mt-11 text-base sm:text-lg lg:text-2xl font-sans leading-relaxed">
        I’m Hardik Vishwakarma, a Software Engineer in progress, currently pursuing my
        Master of Computer Applications (MCA) at Maulana Azad National Institute of 
        Technology (MANIT), Bhopal.
        <br /><br />
        I am passionate about programming, web development, and software engineering,
        with a strong interest in building scalable and impactful solutions. My academic
        journey and practical projects are equipping me with the skills required to grow
        into a professional software engineer.
      </p>

      {/* ⭐ Highlights Section */}
      <h2 className="text-xl sm:text-3xl font-semibold mt-8 sm:mt-12">
        ⭐ Highlights & Successes
      </h2>

      <div className="flex flex-wrap gap-6 sm:gap-20 mt-5">
        <div>
          <h3 className="text-3xl sm:text-4xl font-bold">+1</h3>
          <p className="mt-1 text-gray-300 text-base sm:text-lg">GROUP PROJECTS</p>
        </div>

        <div>
          <h3 className="text-3xl sm:text-4xl font-bold">+2</h3>
          <p className="mt-1 text-gray-300 text-base sm:text-lg">PROJECTS COMPLETED</p>
        </div>

        <div>
          <h3 className="text-3xl sm:text-4xl font-bold">+1</h3>
          <p className="mt-1 text-gray-300 text-base sm:text-lg">
            CERTIFICATIONS & AWARDS
          </p>
        </div>
      </div>

      {/* 🔥 Featured Portfolios Section */}
      <h2 className="text-2xl sm:text-3xl font-semibold mt-12 sm:mt-20 flex items-center gap-2">
        <Folder size={32} className="sm:size-16" /> Featured Portfolios
      </h2>

      <p className="text-gray-300 mt-2 ml-1 sm:ml-2 text-sm sm:text-lg">
        A glimpse into my professional journey.
      </p>

      {/* Cards Grid */}
      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-10">

        {/* Card 1 */}
        {/* <div className="bg-[#1a1818] p-0 sm:p-2 rounded-xl shadow-lg hover:scale-[1.02] transition-all duration-300"> */}
        <a
  href="https://www.hardikvish.me/about"
  target="_blank"
  rel="noopener noreferrer"
  className="block bg-[#1a1818] p-0 sm:p-2 rounded-xl shadow-lg 
             hover:scale-[1.02] transition-all duration-300 cursor-pointer"
>
          <div className="w-full h-[200px] sm:h-[250px] rounded-lg overflow-hidden mb-6">
            <img 
              
              src={left_photo}
              alt="Portfolio Website"
              className="w-full h-full object-cover"
            />
          </div>

          <p className="text-gray-400 text-sm">yourwebsite.com</p>
          <h3 className="text-xl sm:text-2xl font-semibold mt-2">Portfolio Website</h3>
          <p className="text-gray-400 mt-2 text-sm sm:text-base">
            My personal portfolio website showcasing my experience, skills, and achievements.
          </p>
        </a>







        {/* Card 2 */}
        <div className="bg-[#1a1818] p-0 sm:p-2 rounded-xl shadow-lg hover:scale-[1.02] transition-all duration-300">
          <div className="w-full h-[200px] sm:h-[250px] rounded-lg overflow-hidden mb-6">
            <img 
              src={right_photo}
              alt="Terminal Portfolio"
              className="w-full h-full object-cover"
            />
          </div>

          <p className="text-gray-400 text-sm">yourterminalwebsite.com</p>
          <h3 className="text-xl sm:text-2xl font-semibold mt-2">Terminal Portfolio</h3>
          <p className="text-gray-400 mt-2 text-sm sm:text-base">
            An interactive, unique terminal-style portfolio with a retro-inspired experience.
          </p>
        </div>

      </div>
    </div>
  );
}

